import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { GetTotalNotReadNotificationsResData } from "./GetTotalNotReadNotificationsResData";

const ENDPOINT = "/notifications/total_not_read";

export class GetTotalNotReadNotificationsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    constructor() {
        super();
    }

    public async execute(): Promise<GetTotalNotReadNotificationsResData> {
        var res = await this.executeCommand();
        return new GetTotalNotReadNotificationsResData(res);
    }
}
